import { useFormikContext } from 'formik';
import { Plus } from 'lucide-react';

import { Source } from '@/react/portainer/gitops/sources/types';

import { Button } from '@@/buttons';

import { FormValues } from '../../types';

import { SourceFilePicker } from './SourceFilePicker';
import { EmptySourceSlot } from './EmptySourceSlot';
import { useSourceSlots } from './useSourceSlots';

export function SourceSelector({
  gitSources,
  activeIndex,
  activeFiles,
}: {
  gitSources: Array<Source>;
  activeIndex: number;
  activeFiles: FormValues['artifacts'][number]['files'];
}) {
  const { values } = useFormikContext<FormValues>();
  const {
    pendingSourceSlots,
    addSourceSlot,
    removePendingSlot,
    selectPendingSource,
    removeSource,
  } = useSourceSlots();
  const availableSources = gitSources.filter(
    (source) => !values.sources.includes(source.id)
  );
  const canRemoveSourceOrSlot =
    values.sources.length + pendingSourceSlots.length > 1;

  return (
    <>
      {values.sources.map((sourceId) => (
        <SourceFilePicker
          key={sourceId}
          sourceId={sourceId}
          activeIndex={activeIndex}
          activeFiles={activeFiles}
          onRemove={
            canRemoveSourceOrSlot ? () => removeSource(sourceId) : undefined
          }
        />
      ))}

      {pendingSourceSlots.map((key) => (
        <EmptySourceSlot
          key={key}
          slotId={key}
          options={availableSources}
          onSelect={(sourceId) => selectPendingSource(key, sourceId)}
          onRemove={
            canRemoveSourceOrSlot ? () => removePendingSlot(key) : undefined
          }
        />
      ))}

      <Button
        type="button"
        color="default"
        icon={Plus}
        onClick={addSourceSlot}
        disabled={availableSources.length === 0}
        data-cy="workflow-add-source-button"
      >
        Add source
      </Button>
    </>
  );
}
